import type { AssetPosition } from "kubb";
import StateTabGroupInterface from "../../../../components/TabGroup/StateTabGroupInterface";
import { Divider } from "../../../../components/Theme/divider";
import { Heading } from "../../../../components/Theme/heading";
import DisplayIfUserType from "../../../../components/utils/DisplayIfUserType/DisplayIfUserType";
import CreateAssetForm from "../CreateAssetForm";
import AssetPositionAssetLinkCreateForm from "../assetPositionAssetLinks/AssetPositionAssetLinkCreateForm";
import AssetPositionAssetList from "../assetPositionAssetLinks/AssetPositionAssetList";

export default function AssetPositionAssetHistoryTab(props: {
  assetPosition: AssetPosition;
}) {
  const { assetPosition } = props;

  return (
    <>
      <Heading>Asset Position Asset History</Heading>
      <AssetPositionAssetList
        company_id={assetPosition.company_id}
        scheme_id={assetPosition.scheme_id}
        asset_position_id={assetPosition.asset_position_id}
      />
      <DisplayIfUserType userTypes={"admin"}>
        <Divider className={"py-4"} />
        <div className={"py-4"}>
          <Heading>Assign Asset</Heading>
          <StateTabGroupInterface
            tabs={[
              {
                tabName: "Select",
                tabPath: "select",
                tabContent: (
                  <AssetPositionAssetLinkCreateForm
                    assetPosition={assetPosition}
                  />
                ),
              },
              {
                tabName: "Create",
                tabPath: "create",
                tabContent: (
                  <>
                    <h4>Create Asset</h4>
                    <CreateAssetForm
                      companyId={assetPosition.company_id}
                      assetPosition={assetPosition}
                    />
                  </>
                ),
              },
            ]}
          />
        </div>
      </DisplayIfUserType>
    </>
  );
}
